import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { FormattedMessage } from 'react-intl';

import { user as userAction } from 'actions';
import { byIdShape } from 'utils/propTypes';

import PageHeader from 'AppComponents/PageHeader';
import UserImage from 'AppComponents/UserImage';

import NotFound from 'AppViews/NotFound';

import ChargerReviews from './components/ChargerReviews';
import PlaceReviews from './components/PlaceReviews';

import './styles.scss';


class User extends Component {

  static propTypes = {
    chargerReviewsById: byIdShape.isRequired,
    chargersById: byIdShape.isRequired,
    placeReviewsById: byIdShape.isRequired,
    placesById: byIdShape.isRequired,
    routeParams: PropTypes.shape({ username: PropTypes.string }).isRequired,
    userIdsByUsername: byIdShape.isRequired,
    userRequest: PropTypes.func.isRequired,
    usersById: byIdShape.isRequired,
  };

  componentDidMount() {
    const username = this.props.routeParams.username;
    const userId = this.props.userIdsByUsername[username];
    const user = this.props.usersById[userId];
    if (user && (user.charger_reviews === undefined || user.place_reviews === undefined)) {
      this.props.userRequest(username);
    }
  }

  render() {
    const username = this.props.routeParams.username;
    const userId = this.props.userIdsByUsername[username];
    const user = this.props.usersById[userId];

    if (!user) return <NotFound objectType='User' />;

    return (
      <div className='container'>

        <Helmet
          title={user.public_name}
          meta={[
            { name: 'description', content: `View reviews of chargers and nearby places by ${user.public_name}.` }, // eslint-disable-line max-len
          ]}
        />

        <PageHeader title={user.public_name} styleName='page-header'>
          <UserImage user={user} styleName='profile-photo' />
        </PageHeader>

        <section styleName='reviews'>
          <div className='charger'>
            <h3>
              <FormattedMessage
                id='user.chargerReviews.title'
                values={{ reviewCount: user.charger_reviews ? user.charger_reviews.length : 0 }}
                defaultMessage='{reviewCount, plural,
                  =0 {No Charger Reviews}
                  one {One Charger Review}
                  other {# Charger Reviews}}'
              />:
            </h3>
            <ChargerReviews
              reviews={user.charger_reviews}
              chargersById={this.props.chargersById}
              reviewsById={this.props.chargerReviewsById}
            />
          </div>

          <div className='place'>
            <h3>
              <FormattedMessage
                id='user.placeReviews.title'
                values={{ reviewCount: user.place_reviews ? user.place_reviews.length : 0 }}
                defaultMessage='{reviewCount, plural,
                  =0 {No Place Reviews}
                  one {One Place Review}
                  other {# Place Reviews}}'
              />:
            </h3>
            <PlaceReviews
              reviews={user.place_reviews}
              reviewsById={this.props.placeReviewsById}
              placesById={this.props.placesById}
            />
          </div>
        </section>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  usersById: state.users.byId,
  userIdsByUsername: state.users.byUsername,
  chargersById: state.chargers.byId,
  placesById: state.places.byId,
  placeReviewsById: state.places.reviewsById,
  chargerReviewsById: state.chargers.reviewsById,
});

const userRequest = userAction.request;

export default connect(
  mapStateToProps, {
    userRequest,
  },
)(User);



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/User/index.jsx